import { raw, esc } from '../lib/html.js';

// Circular progress. `label` is shown in the middle when given.
export function ring(fraction, { size = 44, stroke = 4, label = '', title = '' } = {}) {
  const f = Math.min(1, Math.max(0, fraction || 0));
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  return raw(`<span class="ring${f >= 1 ? ' ring--done' : ''}" style="width:${size}px;height:${size}px"${title ? ` role="img" aria-label="${esc(title)}"` : ' aria-hidden="true"'}>
    <svg width="${size}" height="${size}" viewBox="0 0 ${size} ${size}" aria-hidden="true">
      <circle class="ring__track" cx="${size / 2}" cy="${size / 2}" r="${r}" fill="none" stroke-width="${stroke}"/>
      <circle class="ring__fill" cx="${size / 2}" cy="${size / 2}" r="${r}" fill="none" stroke-width="${stroke}" stroke-linecap="round"
        stroke-dasharray="${c.toFixed(2)}" stroke-dashoffset="${(c * (1 - f)).toFixed(2)}"${f === 0 ? ' opacity="0"' : ''}/>
    </svg>${label ? `<span class="ring__label">${esc(label)}</span>` : ''}</span>`);
}
